// File: src/import/CheckPermission.js
import { can } from "../utils/perm";

export const CheckPermission = (page) => ({
  View: can(page, "View"),
  Create: can(page, "Create"),
  Edit: can(page, "Edit"),
  Delete: can(page, "Delete"),
  Download: can(page, "Download"),
  BulkUpload: can(page, "BulkUpload"),
});
